export default __webpack_public_path__ + "static/media/H100&H200.212814a9.png";